import { useState, useEffect } from "react";
import { Login } from "./views/Login/Login";
import { Tabs, type Tab } from "./components/Tabs/Tabs";
import { NewSale } from "./views/NewSale/NewSale";
import { SoldTickets } from "./views/SoldTickets/SoldTickets";
import "./App.scss";
import { getAuth } from "firebase/auth";
import type { User } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getLoggedInuser } from "./useCases/users";
import { getActiveLottery } from "./useCases/config";

const firebaseConfig = {
	apiKey: import.meta.env.VITE_API_KEY,
	authDomain: import.meta.env.VITE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_APP_ID,
	measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};

function App() {
	const [loggedInUser, setLoggedInUser] = useState<User | null>(null);
	const [activeLottery, setActiveLottery] = useState<string | null>(null);

	const app = initializeApp(firebaseConfig);
	const analytics = getAnalytics(app);
	const auth = getAuth();

	const db = getFirestore(app);

	useEffect(() => {
		const unsubscribe = auth.onAuthStateChanged(async (newUser) => {
			logEvent(analytics, "login");
			if (newUser) {
				await getLoggedInuser(db, newUser.uid);
				const lottery = await getActiveLottery(db);
				setActiveLottery(lottery);
			}
			setLoggedInUser(newUser);
		});

		return () => unsubscribe();
	}, []);

	const tabs: Tab<"new" | "sold">[] = [
		{
			id: "new",
			label: "Nueva venta",
			content: activeLottery ? (
				<NewSale analytics={analytics} db={db} lottery={activeLottery} />
			) : null,
		},
		{
			id: "sold",
			label: "Ventas registradas",
			content: activeLottery ? (
				<SoldTickets db={db} lottery={activeLottery} />
			) : null,
		},
	];

	if (loggedInUser === null) {
		return <Login auth={auth} db={db} />;
	} else {
		return (
			<div className="app">
				<Tabs
					loggedInUser={loggedInUser}
					auth={auth}
					tabs={tabs}
					initialTabId={tabs[0].id}
				/>
			</div>
		);
	}
}

export default App;
